import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmarkCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32.7279 32.7279C29.3523 36.1036 24.7739 38 20 38C15.2261 38 10.6477 36.1036 7.27208 32.7279C3.89642 29.3523 2 24.7739 2 20C2 15.2261 3.89642 10.6477 7.27208 7.27208C10.6477 3.89642 15.2261 2 20 2C24.7739 2 29.3523 3.89642 32.7279 7.27208C36.1036 10.6477 38 15.2261 38 20C38 24.7739 36.1036 29.3523 32.7279 32.7279ZM18.5505 26.6797L28.8168 16.4135C29.4596 15.8151 29.461 14.7793 28.8209 14.179C28.2207 13.539 27.1848 13.5403 26.5865 14.1832L17.4505 23.3192L13.4129 19.3198C12.8145 18.6775 11.7791 18.6763 11.179 19.3162C10.5389 19.9164 10.5403 20.9523 11.1831 21.5506L16.3122 26.6797C16.9119 27.324 17.9509 27.324 18.5505 26.6797Z"
	})
});
export default SvgCheckmarkCircle;
